import React, { Component } from 'react';


class WWF extends Component {

    render() {
        return (
            <section>
                <div id="top-content-region" className="top-content padding-top-15 padding-bottom-15 block-15 bg-color-grayLight1">
                    <div className="container">
                        <div className="row">
                            <div id="top-content-left-region" className="top-content-left col-xs-12 col-md-6 text-center-sm">
                                <div id="page-title-block" className="page-title block">
                                    <h1>Women's Winter Festival</h1>
                                </div>
                            </div>

                            <div id="top-content-right-region" className="top-content-right col-xs-12 col-md-6 text-right text-center-sm">
                                <div id="page-breadcrumbs-block" className="page-breadcrumbs block">
                                    <div className="breadcrumbs">
                                        <a href="/">Home</a>
                                        <span className="delimiter">›</span>
                                        <span title="" className="nolink">Events</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="content-region">
                    <div className="container">
                        <div className="row">
                            <div id="main-content-region" className="main-content col-xs-12">
                                <div className="region region-content">
                                    <div id="block-system-main" className="block block-system">
                                        <div className="content">
                                            <div className="node node-page clearfix">
                                                <div className="content">
                                                    <p>
                                                        <strong>Event Date: </strong> Monday, June 4, 2018 to Saturday, August 4, 2018<br /><br />

                                                        <strong>Surprising Heroines of the Bible</strong><br /><br />

                                                        <strong>Women's Winter Festival 2018</strong><br /><br />

                                                        Welcoming women of all ages, belief and backgrounds. Come and have your hearts warmed over winter with encouraging Bible talks, delicious soups and dessert, thoughtful discussion groups and great company.<br /><br />

                                                        <strong>Talks on suprising Heroines by:</strong>

                                                        <ul>
                                                            <li>Christine Jolly | June 2</li>
                                                            <li>Amanda-Sue Markham | July 7</li>
                                                            <li>Felicity Ogilvie | August 4</li>
                                                        </ul>



                                                        5pm - 8pm @ 45 Melville Street Hobart<br />
                                                        $5 each night
                                                </p>


                                                </div>



                                            </div>
                                        </div>
                                    </div>  </div>



                            </div>




                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default WWF;
